import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { InjectionToken, PLATFORM_ID, inject } from '@angular/core';

export const PLATFORM = new InjectionToken('PLATFORM', {
    providedIn: 'platform',
    factory: () => {
        const platformId = inject(PLATFORM_ID);
        const document = inject(DOCUMENT);

        const isServerRendered = !!document.getElementById('ng-state');

        return {
            isServer: isPlatformServer(platformId),
            isBrowser: isPlatformBrowser(platformId),
            isServerRendered,
        };
    },
});
